import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery, UseQueryOptions } from 'react-query'
import { Font } from 'types'
import { sendToApi } from 'api/client'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useRootStore } from 'stores/RootStore'

interface Data {
  fonts: Font[]
}

const fetchFonts = (workspaceId: number) => {
  return sendToApi<Data>(`/w/${workspaceId}/fonts`)
}

export const useFonts = (options?: UseQueryOptions<Data>) => {
  const currentWorkspaceId = useCurrentWorkspaceId()
  const { customFonts } = useRootStore()

  return useQuery<Data>(
    ['workspaces', currentWorkspaceId, 'fonts', 'list'],
    async () => {
      const res = await fetchFonts(currentWorkspaceId)
      if (res.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error()
      }
      customFonts.addBulk(res.data.fonts, currentWorkspaceId)
      return res.data
    },
    {
      staleTime: (options?.cacheTime || 0) * 0.5,
      refetchOnWindowFocus: false,
      ...options,
    },
  )
}
